module.exports = __webpack_public_path__ + "img/browse.35819a50.svg";